module.exports = __webpack_public_path__ + "64f19246b47680747fcb8870cae80389.svg";